export default "__VITE_ASSET__3vQCsDbr__"